import React, { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { getPriorityGroups } from '../../redux/slices/odsPriorityGroups/odsPriorityGroupsThunk';
import ODSPriorityGroupLayout from '../../components/SharedLayouts/ODSPriorityGroupLayout/ODSPriorityGroupLayout';
import groups_logo from '../../assets/img/groups.png'

const Index = () => {
  const dispatch = useAppDispatch();

  const { priorityGroups } = useAppSelector((state) => state.ods_priorityGroups);

  useEffect(() => {
    if (!priorityGroups) {
      dispatch(getPriorityGroups());
    };
  }, [priorityGroups, dispatch]);

  return (
    <ODSPriorityGroupLayout
      titleHero='Grupos prioritarios'
      descriptionHero='Esta sección te brinda una mirada transversal de los indicadores del Monitor que refieren a sectores de la población sistemáticamente vulnerados. Se trata de una perspectiva fundamental para estudiar y comprender cómo las desigualdades impactan en el ejercicio de los derechos, con la mirada puesta en el diseño e implementación de políticas transformadoras.'
      imgHero={groups_logo}
      data={priorityGroups ?? []}
    />
  )
}

export default Index